<template lang="pug">
  .h-100
    button.video-controller__button.video-controller__button--leave(
      type="button",
      :data-index="dataIndex",
      @click="leaveRoom",
      @mouseenter="onMouseEnter",
      @mouseleave="onMouseLeave"
    )
      img.video-controller__icon(src="/static/img/app/btn-leave.svg")
    span.text-nowrap.video-controller__tooltip
      | 退出
</template>

<script>
export default {
  name: 'LeaveButton',
  props: [
    'onMouseEnter',
    'onMouseLeave',
    'dataIndex'
  ],
  methods: {
    leaveRoom () {
      location.href = '/'
    }
  }
}
</script>
